export default "# Card 卡片\r\n\r\n通用卡片容器。\r\n\r\n最基础的卡片容器，可承载文字、列表、图片、段落，常用于后台概览页面。\r\n\r\n## 何时使用\r\n\r\n- 查询条件块。\r\n- 查询表格块。\r\n- 详情信息分块。";